import { Injectable } from '@angular/core';
import { StateHandlerService } from '../state-handler/state-handler.service';
import { UtilsService } from '../utils/utils.service';


@Injectable({
  providedIn: 'root',
})
export class CheckFocusService {
  isAppleDevice = false;
  constructor(
    private readonly stateHandlerSvc: StateHandlerService,
    private readonly utilsService: UtilsService
  ) {}

  initFocusListeners() {
    this.isAppleDevice = this.utilsService.isAppleUAPArser();
    this.hasPageFocus();
  }
  /**
   * Método que genera los listeners de los eventos blur y focus,
   * para determinar si la pestaña pierde el foco
   */
  private hasPageFocus() {
    this.resetFocusListeners();
    if (this.isAppleDevice) {
      //Mejor document que window ya que Apple no generea evento blur en window
      document.addEventListener('focus', () => {
        this.stateHandlerSvc.set('focusState', true, false);
        this.stateHandlerSvc.set('blurState', false, false);
        console.log('Check Focus focusState ---->', true);
      });
      document.addEventListener('blur', () => {
        this.stateHandlerSvc.set('blurState', true, false);
        this.stateHandlerSvc.set('focusState', false, false);
        console.log('Check Focus blurState ---->', true);
      });
      //hack para Apple
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          this.stateHandlerSvc.set('blurState', true, false);
          this.stateHandlerSvc.set('focusState', false, false);
          console.log('Check Focus blurState ---->', true);
        } else if (document.visibilityState === 'visible') {
          this.stateHandlerSvc.set('blurState', false, false);
          this.stateHandlerSvc.set('focusState', true, false);
          console.log('Check Focus focusState', true);
        }
      });
    } else {
      window.addEventListener('focus', () => {
        this.stateHandlerSvc.set('focusState', true, false);
        this.stateHandlerSvc.set('blurState', false, false);
      });
      window.addEventListener('blur', () => {
        this.stateHandlerSvc.set('blurState', true, false);
        this.stateHandlerSvc.set('focusState', false, false);
      });
    }
  }

  private resetFocusListeners() {
    this.removeListeners();
  }
  /**
   * Método que elimina los listeners de los eventos
   */
  private removeListeners() {
    if (this.isAppleDevice) {
      document.removeEventListener('focus', () => {});
      document.removeEventListener('blur', () => {});
      document.removeEventListener('visibilitychange', () => {});
    } else {
      window.removeEventListener('focus', () => {});
      window.removeEventListener('blur', () => {});
    }
  }
}
